import { useMemo } from 'react';
import { usePredictionMarketCategories } from '@/lib/endpoints';
import { useAppSearchParams } from '@/hooks/useAppSearchParams';
import { useHiddenCategories } from '@/lib/territory/useTerritory';

/**
 * Category-chip explore block at the bottom of the trending lobby (Figma
 * 5751-141388 "BTN" wrap): a wrapping row of outlined pills — category icon +
 * name — that jump into the category feed via `?category=` (same URL contract
 * as the tab bar). Renders nothing while categories load or when none are
 * visible for the territory.
 */
export function ExploreCategories() {
  const { setCategory } = useAppSearchParams();
  const { data } = usePredictionMarketCategories();
  const hiddenCategories = useHiddenCategories();

  const visible = useMemo(
    () => (data ?? []).filter((cat) => !hiddenCategories.includes(cat.code.toUpperCase())),
    [data, hiddenCategories],
  );

  if (visible.length === 0) return null;

  return (
    <div className="flex w-full flex-wrap content-start items-start gap-2">
      {visible.map((cat) => (
        <button
          key={cat.code}
          type="button"
          onClick={() => setCategory(cat.code)}
          className="flex h-[30px] items-center justify-center gap-1 rounded-[40px] border border-solid border-stroke-soft bg-surface px-2.5 transition-colors hover:bg-black/[0.03]"
        >
          {cat.iconImgUrl && <img src={cat.iconImgUrl} alt="" className="size-[18px] rounded-full object-cover" />}
          <span className="text-[16px] font-normal capitalize text-ink-muted">{cat.displayName ?? cat.code}</span>
        </button>
      ))}
    </div>
  );
}
